<template>
    <v-layout
        row
        wrap
        class="align-start"
        v-if="Object.keys(languageAttributes).length > 0"
        :class="textColor + '--text'"
        id="productSpecification"
    >
        <v-flex v-for="attributes in attributesByColumns" v-bind:key="attributes" xs12 :class="'md' + 12 / cols">
            <v-layout row wrap>
                <template v-for="(attribute, indexname, index) in attributes">
                    <v-flex
                        v-if="!hideLabels"
                        xs6
                        class="font-weight-bold py-0"
                        :key="'public-attribute-name-' + index + _uid"
                    >
                        <v-layout row wrap align-center ma-0>
                            <v-flex v-if="anyIconExists" xs2 class="pa-0 d-flex justify-center">
                                <v-img
                                    v-if="getAttributeTypeIcon(indexname)"
                                    :src="getAttributeTypeIcon(indexname)"
                                    contain
                                    width="25"
                                    height="25"
                                />
                            </v-flex>

                            <v-flex xs10 class="pa-0">
                                {{ attribute.name }}
                            </v-flex>
                        </v-layout>
                    </v-flex>

                    <v-flex xs6 :key="index" class="py-0">
                        <div
                            v-for="(valueName, valueKey, index) in getIterableValue(attribute.value)"
                            :key="'public-attribute-value-' + index + _uid"
                        >
                            <template v-if="attribute.linkToSearch">
                                <router-link
                                    :to="
                                $search.buildSearchParams({
                                    attributes: {
                                        [indexname]: attribute.linkValue != undefined ? attribute.linkValue : valueKey,
                                    },
                                })
                            "
                                >
                                    <template
                                        v-if="additions && additions[indexname] && additions[indexname].viewType === 'image_select'">
                                        <product-specification-image-type
                                            :imagePath="getAdditionValue(indexname, valueName)"
                                            :name="valueName"
                                        />
                                    </template>

                                    <template v-else>
                                        {{ valueName }}
                                    </template>
                                </router-link>

                                <template v-if="index + 1 != Object.values(getIterableValue(attribute.value)).length">
                                    ,
                                </template>
                            </template>

                            <template v-else>
                                <template
                                    v-if="additions && additions[indexname] && additions[indexname].viewType === 'image_select'">
                                    <product-specification-image-type
                                        :imagePath="getAdditionValue(indexname, valueName)"
                                        :name="valueName"
                                    />
                                </template>

                                <template v-else>
                                    <div v-html="valueName" class="text-styles">
                                    </div>
                                </template>


                                <template v-if="index + 1 != Object.values(getIterableValue(attribute.value)).length">
                                    ,
                                </template>
                            </template>
                        </div>
                    </v-flex>
                </template>
            </v-layout>
        </v-flex>
    </v-layout>
</template>

<script>
import ProductSpecificationImageType
    from '@breakmedia/prime-vue-product/src/product-page/ProductSpecificationTypes/Image';
import {mapGetters} from 'vuex';

export default {
    name: 'ProductSpecification',
    components: {
        ProductSpecificationImageType,
    },
    props: {
        attributes: {
            type: Object | Array,
            default: {},
        },
        additions: {
            type: Object,
            default: () => ({}),
        },
        limit: {
            type: Number,
        },
        textColor: String,
        cols: {
            default: 1,
        },
        hideLabels: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapGetters('SearchFilters', ['getAttributeByIndexname']),
        languageAttributes() {
            const lang = this.$language.getLanguage();
            let attributes = {};
            let result = {};

            if (this.attributes && this.attributes[lang]) {
                attributes = this.attributes[lang];
            } else if (this.attributes && Object.values(this.attributes).length > 0) {
                attributes = Object.values(this.attributes)[0];
            }

            if (this.limit) {
                Object.keys(attributes).some((key, index) => {
                    if (index + 1 <= this.limit) {
                        result[key] = attributes[key];
                    } else {
                        return true;
                    }
                });
            } else {
                result = attributes;
            }

            return result;
        },
        anyIconExists() {
            return Object.keys(this.languageAttributes).some(indexname => Boolean(this.getAttributeTypeIcon(indexname)));
        },
        attributesByColumns() {
            let result = {};
            let column = 1;

            if (this.languageAttributes) {
                Object.keys(this.languageAttributes).forEach(key => {
                    if (!result[column]) {
                        result[column] = {};
                    }

                    result[column][key] = this.languageAttributes[key];

                    if (column < this.cols) {
                        column++;
                    } else {
                        column = 1;
                    }
                });
            }

            return result;
        },
    },
    methods: {
        getAdditionValue(indexname, value) {
            if (this.additions[indexname] && this.additions[indexname].additions[value]) {
                return this.additions[indexname].additions[value];
            }
        },
        getIterableValue(value) {
            var result = {};
            if (typeof value == 'string') {
                result = {
                    [value]: value,
                };
            } else if (Array.isArray(value)) {
                result = new Object(value);
            } else if (value != undefined && value != null) {
                result = value;
            }

            return result;
        },
        getAttributeTypeIcon(indexname) {
            let attribute = this.getAttributeByIndexname(indexname);

            if (attribute) {
                return attribute.icon;
            }
        },
    },
};
</script>
<style>
.text-styles p {
    margin-bottom: 0;
}

.text-styles ul, ol {
    padding-left: 0;
}

.text-styles li {
    padding-bottom: 3px;
}

.text-styles br {
    display: none;
}
</style>